import React from 'react'

export default function CardPopularList({item, onClick}) {

    return (
        <div
            onMouseDown={onClick}
            className={"card-popular-list"}>
           <div className={"count"}>
                <span>
                    {item.id}
                </span>
           </div>
            <div className={"about"}>
                <div className={"title"}>
                    <a>
                        {item.name}
                    </a>
                </div>
            </div>

        </div>
    )
}
